<template>
    <div class="main-content__wizzard">
        <div class="wizzard__content">
            <h2 class="wizzard__step-title" v-translate>
                Define each step
            </h2>
            <div class="message message--with-icon message--info" v-translate>
                Start by defining first activity, after you are finish click "Save and edit next activity" to continue
                with next one. After you finish with defining all activities, button to continue to next step will show
                on the bottom.
            </div>
            <form class="form">
                <ul class="wizzard__steps-to-objective">
                    <add-activity-step-details v-for="(activity, index) in objective.activities"
                                               :editing_index="editing_index" :my_index="index"
                                               :parent_activity="activity" :objective="objective"
                                               @save="incrementIndex(index+1)" :key="'activity'+index"/>

                    <!--
                    <li>
                        <div class="steps-to-objective__activity steps-to-objective__activity--currently-editing">
                            <div class="steps-to-objective__activity-title">Meeting with Phil regarding investors
                                contacts
                            </div>
                            <form class="form steps-to-objective__define-activity">
                                <div class="form__group">
                                    <div class="form__field">
                                        <label for="labelid" class="form__label">Describe your activity</label>
                                        <textarea type="text" id="labelid"
                                                  class="textarea textarea--autoresize"></textarea>
                                    </div>
                                </div>
                                <div class="form__group-category">
                                    <div class="your-dates__category">
                                        <span class="main-category-icon main-category-icon--not-set"
                                              title="Category: Business"></span>
                                    </div>
                                    <div class="form__group">
                                        <div class="form__field">
                                            <label for="labelid" class="form__label">Category</label>
                                            <input type="text" id="labelid" class="input--text">
                                        </div>
                                    </div>
                                    <div class="form__group">
                                        <div class="form__field">
                                            <label for="labelid" class="form__label">Subcategory</label>
                                            <input type="text" id="labelid" class="input--text">
                                        </div>
                                    </div>
                                </div>
                                <div class="form__group">
                                    <div class="form__field">
                                        <label for="labelid" class="form__label">Your expected result</label>
                                        <textarea type="text" id="labelid"
                                                  class="textarea textarea--autoresize"></textarea>
                                    </div>
                                </div>
                                <div class="form__group">
                                    <div class="form__field">
                                        <label for="labelid" class="form__label">How will you measure it</label>
                                        <textarea type="text" id="labelid"
                                                  class="textarea textarea--autoresize"></textarea>
                                    </div>
                                </div>
                                <div class="your-dates__date">
                                    <div class="your-dates__date-title">
                                        When will you
                                        <strong>Do It?</strong>
                                    </div>
                                    <div class="your-dates__category">
                                        <span class="main-category-icon icon-business"
                                              title="Category: Business"></span> Negotiation
                                    </div>
                                    <div class="your-dates__date-strength">
                                        Strength of your day:
                                        <div class="date-strength date-strength--good">?</div>
                                    </div>
                                </div>
                                <button @click="openPopup(choose_date)" class="button button--gray" type="button">Choose
                                    date
                                </button>

                                <div class="form__action-buttons form__action-buttons--inline">
                                    <a href="javascript:;" class="button button--primary">Save and edit next
                                        activity</a>
                                </div>
                            </form>
                        </div>
                    </li>
                    <li>
                        <div class="steps-to-objective__activity">
                            <div class="steps-to-objective__activity-title">Name of small step #3</div>
                            <form class="form steps-to-objective__define-activity">
                                <div class="form__group form__group--error">
                                    <div class="form__field">
                                        <label for="labelid" class="form__label">Describe what will you do in this step
                                            ...</label>
                                        <textarea type="text" id="labelid"
                                                  class="textarea textarea--autoresize"></textarea>
                                    </div>
                                    <div class="form__msg form__msg--error">Please describe your activity.</div>
                                </div>
                                <div class="form__group-category">
                                    <div class="your-dates__category">
                                        <span class="main-category-icon main-category-icon--not-set"
                                              title="Category: Business"></span>
                                    </div>
                                    <div class="form__group">
                                        <div class="form__field">
                                            <label for="labelid" class="form__label">Category</label>
                                            <input type="text" id="labelid" class="input--text">
                                        </div>
                                    </div>
                                    <div class="form__group">
                                        <div class="form__field">
                                            <label for="labelid" class="form__label">Subcategory</label>
                                            <input type="text" id="labelid" class="input--text">
                                        </div>
                                    </div>
                                </div>
                                <div class="form__group">
                                    <div class="form__field">
                                        <label for="labelid" class="form__label">Describe what will you do ...</label>
                                        <textarea type="text" id="labelid"
                                                  class="textarea textarea--autoresize"></textarea>
                                    </div>
                                </div>
                                <div class="form__group">
                                    <div class="form__field">
                                        <label for="labelid" class="form__label">Describe how will you measure it
                                            ...</label>
                                        <textarea type="text" id="labelid"
                                                  class="textarea textarea--autoresize"></textarea>
                                    </div>
                                </div>
                                <div class="your-dates__date">
                                    <div class="your-dates__date-title">
                                        Saturday
                                        <strong>25. Feb 2019</strong>
                                    </div>
                                    <div class="your-dates__category">
                                        <span class="main-category-icon icon-business"
                                              title="Category: Business"></span> Subcategory
                                    </div>
                                    <div class="your-dates__date-strength">
                                        Strength of your day:
                                        <div class="date-strength date-strength--perfect"><strong>Perfect</strong></div>
                                    </div>
                                </div>
                                <button class="button button--gray openPopup" data-open-popup-id="choose-date-popup"
                                        type="button">Change selected date
                                </button>
                            </form>
                        </div>
                    </li>
                    -->
                    <li class="steps-to-objective__finish">
                        <div class="steps-to-objective__activity-title" v-translate>Objective completed</div>
                    </li>
                </ul>
                <div class="form__action-buttons">
                    <a v-if="editing_index>=objective.activities.length" href="javascript:;" class="button button--primary" @click="submit()" v-translate>
                        Next step
                    </a>
                    <a href="javascript:;" class="button button--transparent" @click="$emit('advance','step-2')" v-translate>
                        Previous step
                    </a>
                </div>
            </form>
        </div>
        <div class="wizzard__tips">
            <h2 v-translate>Quick tips</h2>
            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aliquid aperiam eligendi eos facilis
                illo, ipsa iste, laboriosam laudantium porro qui similique, sit suscipit tempore vero voluptate.
                Eaque impedit porro quae.</p>
            <p>Ab adipisci deserunt eius expedita explicabo, facilis, in mollitia natus provident quam quisquam,
                quo reiciendis repudiandae temporibus vel velit voluptate. Adipisci ducimus eligendi itaque,
                nesciunt pariatur perferendis rerum totam voluptates.</p>
            <p>Assumenda consequatur eaque est expedita hic labore maiores, molestias odio perferendis repellat
                soluta tempore voluptatem. Facilis in inventore itaque neque repellat unde ut. A animi
                architecto consequatur consequuntur quibusdam, quos.</p>
        </div>
    </div>
</template>
<script>
    import ChooseDate from "./popups/ChooseDate";
    import AddActivityStepDetails from "./AddActivityStepDetails";

    export default {
        name: 'plan-objective-step-three',
        components: {AddActivityStepDetails},
        data() {
            return {
                objective: {},
                choose_date: ChooseDate,
                editing_index: 0
            }
        },
        props: {
            parent_objective: {},
        },
        beforeMount: function () {
            this.objective = this.parent_objective
        },
        methods: {
            incrementIndex: function(new_index) {
                if (this.editing_index<=new_index) {
                    this.editing_index=new_index
                }
            },
            submit: function() {
                this.$emit('advance','step-4')
            }
        }
    }
</script>